<template>
  <FormGroup
    :label="label"
    :inputId="idCalc"
    :errors="errorsCalc"
    labelClass="!nx-text-body2 tw-font-medium"
    :successes="successes"
  >
    <template #label>
      <slot name="label" />
    </template>
    <VueSelect
      class="vue-select-form-control tw-bg-background"
      :class="{ 'is-invalid': errorsCalc, 'is-valid': successes }"
      :data-test="testId"
      :options="getOptions()"
      :reduce="(item) => item.value"
      label="display"
      @update:modelValue="emitInput"
      :value="modelValue"
    />
  </FormGroup>
</template>

<script>
import "vue-select/dist/vue-select.css";
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";
import VueSelect from "vue-select";

export default {
  name: "FormAutocompleteSelect",
  components: {
    FormGroup,
    VueSelect,
  },
  mixins: [FormMixin],
  emits: ["input", "update:modelValue"],
  props: {
    testId: {
      type: String,
      default: "",
    },
    modelValue: [String, Number, Object],
    options: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const emitInput = (value) => {
      emit("input", value);
      emit("update:modelValue", value);
    };

    const getOptions = () =>
      props.options.map((item) => {
        if (typeof item === "object") {
          return { ...item, ...{ disabled: false } };
        }
        return { display: item, value: item, disabled: false };
      });

    return {
      emitInput,
      getOptions,
    };
  },
};
</script>
